module.exports = __webpack_public_path__ + "static/media/t2.800006a0.jpg";